import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import {
  brandFieldControlClassName,
  surfaceFieldControlClassName,
} from "@/components/ui/field-styles"
import { cn } from "@/lib/utils"

const inputVariants = cva(
  "flex w-full min-w-0 border outline-none transition-[color,box-shadow] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 focus-visible:ring-[3px]",
  {
    variants: {
      variant: {
        default:
          "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-10 rounded-lg bg-transparent px-3 py-2 text-base shadow-xs file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium md:text-sm focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        surface:
          "px-3 py-2 aria-invalid:border-destructive aria-invalid:ring-destructive/20 " +
          surfaceFieldControlClassName,
        brand:
          "px-3 py-2 focus-visible:ring-[3px] aria-invalid:border-destructive aria-invalid:ring-destructive/20 " +
          brandFieldControlClassName,
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Input({
  className,
  type,
  variant,
  ...props
}: React.ComponentProps<"input"> & VariantProps<typeof inputVariants>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(inputVariants({ variant }), className)}
      {...props}
    />
  )
}

export { Input }
